import { reqLogin, reqPermission } from "../api";
import {
  GET_LOGIN,
  GET_PERMISSION,
  CHANGE_SETTING,
  SET_SIZE
} from "./mutation-types";

export default {
  async getLogin({ commit }, params) {
    //登录
    let login = await reqLogin(params);
    commit(GET_LOGIN, { login });
  },
  async getPermission({ commit }, params) {
    //获取权限
    let permission = await reqPermission(params);
    commit(GET_PERMISSION, { permission });
  },
  changeSetting({ commit }, data) {
    commit(CHANGE_SETTING, data);
  },
  setSize({ commit }, size) {
    commit(SET_SIZE, size);
  }
};
